import React from "react";
import { dynamicColor } from "components/table/table-parts";

interface ActionButtonProps {
  icon?: React.JSX.Element;
  text?: string;
  title?: string;
  color: string;
  action: () => void;
  disabled?: boolean;
  modal: boolean;
  modal_id?: string;
}

const ActionButton: React.FC<ActionButtonProps> = ({ icon, text, title, color, action, disabled, modal, modal_id }) => {
  const modalBtnProps = {
    "data-bs-toggle": "modal",
    "data-bs-target": modal_id,
  };

  const additionalBtnProps = modal ? modalBtnProps : {};

  return (
    <button
      type="button"
      className={`btn ${text ? undefined : "btn-icon"} ${dynamicColor(color)}`}
      title={title}
      onClick={action}
      disabled={disabled}
      {...additionalBtnProps}
    >
      {icon}
      {text}
    </button>
  );
};

export default ActionButton;
